export const internalGlobalObjectKey = '_faroInternal';
//# sourceMappingURL=const.js.map